export class InitializedComment {
  public content: string | null = null;
  public carEvidenceId: string | null = null;
}
